/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Placeholder_RoleInputs */

const en_jobs_placeholder_role = /** @type {(inputs: Jobs_Placeholder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Developer`)
};

const de_jobs_placeholder_role = /** @type {(inputs: Jobs_Placeholder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Senior Frontend Developer`)
};

const fr_jobs_placeholder_role = /** @type {(inputs: Jobs_Placeholder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Senior Frontend Developer`)
};

const es_jobs_placeholder_role = /** @type {(inputs: Jobs_Placeholder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Senior Frontend Developer`)
};

const it_jobs_placeholder_role = /** @type {(inputs: Jobs_Placeholder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Senior Frontend Developer`)
};

const nl_jobs_placeholder_role = /** @type {(inputs: Jobs_Placeholder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. Senior Frontend Developer`)
};

const pl_jobs_placeholder_role = /** @type {(inputs: Jobs_Placeholder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`np. Senior Frontend Developer`)
};

const fi_jobs_placeholder_role = /** @type {(inputs: Jobs_Placeholder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esim. Senior Frontend -kehittäjä`)
};

const da_jobs_placeholder_role = /** @type {(inputs: Jobs_Placeholder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. Senior Frontend-udvikler`)
};

const sv_jobs_placeholder_role = /** @type {(inputs: Jobs_Placeholder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`t.ex. Senior Frontend-utvecklare`)
};

/**
* | output |
* | --- |
* | "e.g. Senior Frontend Developer" |
*
* @param {Jobs_Placeholder_RoleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_placeholder_role = /** @type {((inputs?: Jobs_Placeholder_RoleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Placeholder_RoleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_placeholder_role(inputs)
	if (locale === "fr") return fr_jobs_placeholder_role(inputs)
	if (locale === "es") return es_jobs_placeholder_role(inputs)
	if (locale === "it") return it_jobs_placeholder_role(inputs)
	if (locale === "nl") return nl_jobs_placeholder_role(inputs)
	if (locale === "pl") return pl_jobs_placeholder_role(inputs)
	if (locale === "fi") return fi_jobs_placeholder_role(inputs)
	if (locale === "da") return da_jobs_placeholder_role(inputs)
	if (locale === "sv") return sv_jobs_placeholder_role(inputs)
	return en_jobs_placeholder_role(inputs)
});